import { resolveApiBaseUrl } from '../utils/apiBase';
import { ensureCsrfCookie, xsrfHeaders } from './authApi';

const API_BASE = resolveApiBaseUrl();

async function errorMessage(res) {
  try {
    const body = await res.json();
    if (body?.message) return body.message;
    if (body?.error) return body.error;
  } catch {
    // ignore
  }
  return `${res.status} ${res.statusText}`;
}

/** Returns null when anonymous (401). */
export async function fetchUiPreferences() {
  const res = await fetch(`${API_BASE}/v1/auth/preferences`, { credentials: 'include' });
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(await errorMessage(res));
  return res.json();
}

export async function updateUiPreferences(uiTheme) {
  await ensureCsrfCookie();
  const res = await fetch(`${API_BASE}/v1/auth/preferences`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...xsrfHeaders(),
    },
    credentials: 'include',
    body: JSON.stringify({ uiTheme }),
  });
  if (!res.ok) throw new Error(await errorMessage(res));
  return res.json();
}
